import { render, staticRenderFns } from "./mobileBanner.vue?vue&type=template&id=f87154fe&scoped=true"
import script from "./mobileBanner.vue?vue&type=script&lang=js"
export * from "./mobileBanner.vue?vue&type=script&lang=js"
import style0 from "./mobileBanner.vue?vue&type=style&index=0&id=f87154fe&prod&lang=scss"
import style1 from "./mobileBanner.vue?vue&type=style&index=1&id=f87154fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87154fe",
  null
  
)

export default component.exports